// extracted by mini-css-extract-plugin
module.exports = {"timer":"CountDownTimer_timer__q6LV1","date":"CountDownTimer_date__Sja-Y","timeLeft":"CountDownTimer_timeLeft__k2ARz","interval":"CountDownTimer_interval__4AyRn"};